import { render, staticRenderFns } from "./userCommentThreads.vue?vue&type=template&id=1652899c&lang=pug"
import script from "./userCommentThreads.vue?vue&type=script&lang=js"
export * from "./userCommentThreads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports